import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../services/analyticsService';

/**
 * Component to track page views in a React Router application
 * This is needed because Google Analytics doesn't automatically track 
 * navigation in single-page applications
 */
const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track pageview with Google Analytics
    analyticsService.trackPageView(location.pathname, document.title);
    
    // You can also track additional metrics relevant to SEO here
    // For example, tracking which sections of your app are most visited
  }, [location]);
  
  return null; // This component doesn't render anything
};

export default RouteTracker;
